module.exports = __webpack_public_path__ + "static/media/pic3.673044d2.jpg";